exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".timelineTrackContextMenuItem{display:flex}.timelineTrackContextMenuSpacer{width:20px;flex:1}.timelineTrackContextMenuPid{color:var(--grey-90-a60)}.react-contextmenu-item:hover .timelineTrackContextMenuPid{color:#fff}", ""]);

